import { Directive, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({ selector: '[appConnectForm]' })
export class ConnectFormDirective {
  @Input('appConnectForm')
  set data(val: any) {
    if (val) {
      this.formGroupDirective.form.patchValue(val, { emitEvent: false });
      this.formGroupDirective.form.markAsPristine();
    }
  }
  constructor(private formGroupDirective: FormGroupDirective) {}
}
